import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FuseDirectivesModule } from '../../../../@fuse/directives/directives';
import { AppRoutesName } from '../../const/AppRoutesName';
import { authGuard } from '../../gards/auth-guard';
import { UpgradeRequestComponent } from './upgrade-request.component';

const routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.UPGRADE_REQUEST,
    component: UpgradeRequestComponent,
    canActivate: [authGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.UPGRADE_REQUEST,
    component: UpgradeRequestComponent,
    canActivate: [authGuard],
  },
];

/** Mise à niveau [PRO] (paywall) — page « Demander une mise à niveau ». */
@NgModule({
  declarations: [UpgradeRequestComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FuseDirectivesModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    RouterModule.forChild(routes),
    TranslateModule,
  ],
  exports: [UpgradeRequestComponent],
})
export class UpgradeModule {}
